import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon, Text, TextStyles } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./holding-image.module.css";
var HoldingImage = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ _jsxs("div", {
        className: cx(styles.holdingImage, className),
        children: [
            /*#__PURE__*/ _jsx(SvgIcon, {
                className: styles.icon,
                fill: "currentColor",
                name: "vehicle-side",
                size: 64
            }),
            /*#__PURE__*/ _jsx(Text, {
                type: TextStyles.menuTitle,
                children: text
            })
        ]
    });
};
export default HoldingImage;
